import {Component, ChangeDetectionStrategy} from '@angular/core';
import {SeFeCardModule} from 'se-fe-card';
import {SeFeEmptyStateModule} from 'se-fe-empty-state';
import {SeFeGridModule} from 'se-fe-grid';
import {SeFeHeaderModule} from 'se-fe-header';
import {SeFePageModule} from 'se-fe-page';
import {SeFeIconModule} from 'se-fe-icon';

@Component({
  selector: 'se-not-found',
  template: `
    <se-fe-page [seFeDataLoaded]="true" SeFeDataWidth="full">
      <div seFePageHeader>
        <se-fe-header seFePageHeader seFeDataTitle="Commerce" size="750"></se-fe-header>
      </div>
      <se-fe-card seFePageContent>
        <se-fe-grid>
          <se-fe-card-content>
            <se-fe-grid seFeGridOpts="center">
              <se-fe-grid-cell>
                <se-fe-empty-state seFeDataTitle="Whoa, that's not in the playbook">
                  <se-fe-icon seFeEmptyStateIcon seFeDataName="spot_clipboard" seFeDataSize="950"></se-fe-icon>
                  <p>The page you're looking for may not exist or may have moved</p>
                </se-fe-empty-state>
              </se-fe-grid-cell>
            </se-fe-grid>
          </se-fe-card-content>
        </se-fe-grid>
      </se-fe-card>
    </se-fe-page>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SeFeCardModule, SeFeEmptyStateModule, SeFeGridModule, SeFeHeaderModule, SeFePageModule, SeFeIconModule],
})
export class NotFoundComponent {}
